<div class="container">
    <div class="row mar-top-150 text-center">
        <div class="col-md-12">
            <div class="error-template">
                <h1 class="mar-top-50">
                    Oops!</h1>
                <h2 class="mar-top-30">
                    404 Not Found</h2>
                <div class="error-details mar-top-30">
                    Sorry, an error has occured, Requested page not found!
                </div>
                <div class="error-actions mar-top-30">
                    <a href="#" routerLink="/login" class="btn btn-primary btn-lg"><span class="glyphicon glyphicon-home"></span>
                        Take Me Home </a>
                </div>
            </div>
        </div>
    </div>
</div>